import YICUClassPage from "./YICUClassPage";

const CONTENT = {
  winnerPhotos: [
    { src: "/images/YICU/2023/YICU2023winners1.jpg", caption: "2023 YICU Individual Winners — Tanner Dowd, Pranathi Ganti, Zoe Przybylski, Adithya Komandur, Bradley Ross Jackson, Hemanth Itte, Brian Senn, Vivaan Reddy, Harshal Joshi, and Pritika Jakka" },
    { src: "/images/YICU/2023/YICU2023winners2.jpg", caption: "2023 YICU Special Award Winners" },
  ],
  winners: [
    { label: "Individual Winners (10)", color: "pink", items: ["Tanner Dowd", "Pranathi Ganti", "Zoe Przybylski", "Adithya Komandur", "Bradley Ross Jackson", "Hemanth Itte", "Brian Senn", "Vivaan Reddy", "Harshal Joshi", "Pritika Jakka"] },
    { label: "Team Award", color: "purple", items: ["NCHS ADP 2024 STEM — Tanner Dowd, Steven Robinson, Isha Gollapudi, Kylee Anderson, Jake Claus, Jason Bliss, Devin Diaz, Maya Gopinathan, and Ram Parapatmuni"] },
    { label: "Advocate Award", color: "green", items: ["Not In Our School (NIOS) NCHS, Bloomington-Normal, IL"] },
    { label: "Mentor Award", color: "purple", items: ["Meta Mickens Baker"] },
  ],
};

export default function Yicu2023() {
  return <YICUClassPage year="2023" logoSrc="/images/YICU/2023/YICU2023.png" content={CONTENT} />;
}